import { render, staticRenderFns } from "./ResourcesIntro.vue?vue&type=template&id=07d1f66a&"
import script from "./ResourcesIntro.vue?vue&type=script&lang=js&"
export * from "./ResourcesIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports